var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClickinline = function SvgClickinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 23 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11 2a9 9 0 0 0-1.351 17.9 1 1 0 1 1-.298 1.977C4.058 21.081 0 16.515 0 11 0 4.925 4.925 0 11 0c5.515 0 10.08 4.058 10.877 9.351a1 1 0 0 1-1.978.298A9 9 0 0 0 11 2m11.77 16.516-2.588-2.587 1.802-1.802a.787.787 0 0 0-.485-1.338l-8.642-.786a.785.785 0 0 0-.853.854l.785 8.643a.786.786 0 0 0 1.338.485l1.802-1.803 2.587 2.588a.783.783 0 0 0 1.11 0l3.144-3.143a.785.785 0 0 0 0-1.111M5.998 10.6a5 5 0 0 1 9.513-1.682 1 1 0 0 0 1.812-.848 7 7 0 1 0-9.514 9.206 1 1 0 0 0 .906-1.784 4.998 4.998 0 0 1-2.717-4.892",
    clipRule: "evenodd"
  })));
};
export default SvgClickinline;